import * as React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { Icons } from '@shared/ui-components';
import { FaqCaption } from 'common/enums/faq-caption';
import { State } from 'common/interfaces/state';
import { RedirectUrlUtils } from 'common/utils/redirect-url-utils';
import { AccountSelectors } from 'unit-account/selectors';
import { PageHeaderAvatar } from '../page-header-avatar';
import { Styled } from './styled';


interface BackUrlProps {
  redirectUrl: string;
  // logo?: JSX.Element;
}

interface Props extends BackUrlProps {
  faqCaption?: FaqCaption;
  hasSelectedCompanyActiveSubscription: boolean;
}

const ArrowBack = Icons.SmallArrow;

const BackLink: React.FC<BackUrlProps> = (props: BackUrlProps): JSX.Element => {
  const redirectUrl = RedirectUrlUtils.getRedirectUrlFromQueryParamsUrl();
  const logo = <ArrowBack width={20} />;

  return redirectUrl ? (
    <a href={redirectUrl} className='page-header__logo'>{logo}</a>
  ) : (
    <Link to={props.redirectUrl} className='page-header__logo'>{logo}</Link>
  );
};

class PageHeaderComponent extends React.Component<Props> {
  public render(): React.ReactNode {
    const { hasSelectedCompanyActiveSubscription, redirectUrl } = this.props;
    return (
      <Styled.Container>
        {hasSelectedCompanyActiveSubscription && <BackLink redirectUrl={redirectUrl} />}
        <Styled.RightSide>
          <Styled.Content>
            {this.props.children}
          </Styled.Content>
          <Styled.UserMenu>
            <PageHeaderAvatar />
          </Styled.UserMenu>
        </Styled.RightSide>
      </Styled.Container>
    );
  }
}

function mapStateToProps(state: State): Pick<Props, 'hasSelectedCompanyActiveSubscription'> {
  return {
    hasSelectedCompanyActiveSubscription: AccountSelectors.hasSelectedCompanyActiveSubscription(state),
  };
}

export const PageHeader = connect(mapStateToProps)(PageHeaderComponent);
